import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import BackgroundImageContainer from "./ui/backgroundImageContainer";
import { useInviteStudyStore } from "./model/useDataStore";

export const JoinStudy = () => {
  const { uuid } = useParams();

  const { inviteStudyInfo, setInviteStudyInfo } = useInviteStudyStore();
  const [isLoading, setIsLoading] = useState(true);
  const [isDataExist, setIsDataExist] = useState(false);

  const fetchData = async () => {
    const res = await fetch(`https://api.bbip.site/study/invite-info/${uuid}`);
    if (res.status === 200) {
      const data = await res.json();
      setInviteStudyInfo(data);
      setIsDataExist(true);
      setIsLoading(false);
      console.log(data);
    } else {
      setIsDataExist(false);
      setIsLoading(false);
    }
  };

  const params = {
    studyId: inviteStudyInfo.studyId,
    studyName: inviteStudyInfo.studyName,
    ...(!!inviteStudyInfo.studyImageUrl && {
      imageUrl: inviteStudyInfo.studyImageUrl,
    }),
    ...(!!inviteStudyInfo.studyDescription && {
      studyDescription: inviteStudyInfo.studyDescription,
    }),
  };
  const urlParams = new URLSearchParams(params);
  const queryString = urlParams.toString().replace(/\+/g, "%20");

  const appstoreLink = `https://apps.apple.com/kr/app/bbip/id6670203690?l=en-GB`;
  const deepLink = `bbip://inviteStudy?${queryString}`;
  // const deepLink = `bbiplink.supalink.cc`;

  useEffect(() => {
    fetchData();
  }, []);

  const handleClickJoin = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/i.test(userAgent);
    console.log(isIOS);
    if (isIOS) {
      // 앱이 설치 안 되어 있으면 fallback으로 앱스토어 이동
      setTimeout(() => {
        window.location.href = appstoreLink;
      }, 100); // 앱이 열릴 시간이 필요하므로 살짝 delay 줌
      window.location.href = deepLink;
    }
  };
  if (isLoading) {
    return <div>Loading...</div>;
  }
  // if (!isDataExist) {
  //   return <div>Study not found</div>;
  // }

  return (
    <>
      <div className="mb-28">
        <div className="flex justify-center items-center mt-20">
          <div className="flex justify-center items-center rounded-full w-72 h-72 bg-[#353C49]">
            <BackgroundImageContainer inviteStudyInfo={inviteStudyInfo} />
          </div>
        </div>
        {/* 위에 그 모집중 그거.. 컨테이너... */}
        <div className="flex justify-center my-6 relative">
          <div className="absolute">
            <div className="absolute w-[159px] h-[129px] bottom-[-36px] bg-[url('./img/Ellipse383.png')] bg-auto" />
            <div className="absolute w-[159px] h-[127px] bottom-[-36px] bg-[url('./img/Ellipse384.png')] bg-auto" />
            <div className="absolute w-[27px] h-[27px] bg-[#353C49] bottom-[72px] left-[140px] rounded-full">
              <div className="absolute w-[10px] h-[6px] bottom-[17px] left-[14px] bg-[#A4ADBC] rounded-[50%/50%] rotate-[40deg]" />
            </div>
          </div>
          <div className="relative rounded-xl w-[136px] h-[45px] bg-[#353C49] flex justify-center items-center">
            <span className="text-white text-lg">모집 중</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="fixed w-full h-full bg-[url('./img/3.png')] bg-auto bg-top bg-contain bg-no-repeat min-w-[375px] min-h-[280px] max-w-[486px] mt-7" />
          <div className="z-10 w-full h-full min-w-[375px] min-h-[280px] max-w-[486px] mt-7">
            <div className="mb-4">
              <div className="flex text-[#353C49] justify-start font-bold text-base pl-6">
                한줄 소개
              </div>
              <div className="flex text-[#353C49] text-sm rounded-xl mx-4 bg-white p-3 mt-4 whitespace-pre-wrap">
                <div
                  className={
                    !!inviteStudyInfo.studyDescription ? "" : "opacity-50"
                  }
                >
                  {!!inviteStudyInfo.studyDescription
                    ? inviteStudyInfo.studyDescription
                    : "-"}
                </div>
              </div>
            </div>
            <div className="mb-4">
              <div className="flex text-[#353C49] justify-start font-bold text-base pl-6">
                기간
              </div>
              <div className="flex text-[#353C49] text-sm rounded-xl mx-4 bg-white p-3 mt-4 whitespace-pre-wrap">
                {inviteStudyInfo.studyStartDate} ~{" "}
                {inviteStudyInfo.studyEndDate} (총 {inviteStudyInfo.totalWeeks}
                주차)
              </div>
            </div>
            <div className="mb-4">
              <div className="flex text-[#353C49] justify-start font-bold text-base pl-6">
                주차별 계획
              </div>
              {inviteStudyInfo.studyContents &&
                inviteStudyInfo.studyContents.map((content, index) => (
                  <div className="flex text-[#353C49] text-sm rounded-xl mx-5 bg-white p-3 mt-4 whitespace-pre-wrap flex-row">
                    <div className="flex min-w-[50px] mr-2 justify-center items-center">
                      <div className="justify-between items-center rounded-[10px] text-xs text-[#FF3030] border-[1px] border-[#FF3030] px-1.5 py-0.5 text-center">
                        {index + 1}주차
                      </div>
                    </div>
                    <div
                      className={
                        !!content ? "flex-grow" : "flex-grow opacity-50"
                      }
                    >
                      {!!content ? content : "-"}
                    </div>
                  </div>
                ))}
            </div>
            <div className="mb-4">
              <div
                className="flex text-[#353C49] text-sm rounded-xl mx-5 bg-white p-3 mt-4 whitespace-pre-wrap flex-row justify-between"
                onClick={() =>
                  (window.location.href =
                    "https://possible-raft-360.notion.site/BBIP-114aea0c293b81d7820ae57115c6af3f")
                }
              >
                <div className="mt-3 ml-1">
                  <div className="text-xs text-[#FF3030] font-medium">
                    삡이 처음이라면?
                  </div>
                  <div className="flex font-semibold text-base items-center">
                    <span>BBIP 이용 가이드 살펴보기</span>
                    <Chevron />
                  </div>
                </div>
                <div className="bg-[url('./img/logo.png')] bg-auto bg-contain bg-no-repeat bg-center w-[50px] h-[60px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="z-20 fixed rounded-xl bottom-[52px] w-full text-center left-[50%] transform translate-x-[-50%] flex justify-center items-center">
        <div
          className="text-xl w-full rounded-xl text-white font-medium h-[56px] max-w-[446px] min-w-[335px] mx-5 bg-[#FF3030] justify-center items-center flex cursor-pointer"
          // onClick={() => (window.location.href = deepLink)}
          onClick={handleClickJoin}
        >
          참여하기
        </div>
      </div>
    </>
  );
};

const Chevron = styled.span`
  margin-left: 12px;
  display: flex;
  align-items: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #ff3030;

  &:after {
    content: "";
    display: inline-block;
    border-style: solid;
    border-width: 0 1px 1px 0;
    width: 4px;
    height: 4px;
    transform: rotate(-45deg);
    border-color: #fff;
    margin-left: 4px;
  }
`;
